<fr-toolbar (togglePersonalContentPlugin)="rightSidenav.toggle()"></fr-toolbar>

<mat-sidenav-container
  [hasBackdrop]="false"
  [style.marginTop.px]="(isMobile$ | async) ? 56 : 0"
  autosize
  class="grow shrink-0 basis-auto md:grow md:shrink md:basis-0"
>
  <mat-sidenav
    [disableClose]="true"
    [fixedInViewport]="isMobile$ | async"
    [mode]="'side'"
    [opened]="true"
    [style.width]="(sidebarExpanded$ | async) ? '250px' : 'auto'"
    class="sidebar-sidenav"
    fixedTopGap="56"
  >
    <fr-sidebar class="h-full"></fr-sidebar>
  </mat-sidenav>

  <mat-sidenav
    #rightSidenav
    [autoFocus]="true"
    [fixedInViewport]="isMobile$ | async"
    [mode]="(isMobile$ | async) ? 'over' : 'side'"
    [style.max-width]="(isMobile$ | async) ? '90%' : '30%'"
    [style.min-width]="(isMobile$ | async) ? '90%' : '30%'"
    [style.width]="(isMobile$ | async) ? '90%' : '30%'"
    fixedTopGap="56"
    position="end"
  >
    <pc-plugin></pc-plugin>
  </mat-sidenav>

  <mat-sidenav-content>
    <div [ngClass]="['flex flex-col md:h-full', (forceFullHeight$ | async) ? 'h-full' : '']">
      <fr-app-broadcast [broadcast]="appBroadcast$ | async">

      </fr-app-broadcast>

      <fr-broadcast-message [broadcastMessage]="broadcastMessage"></fr-broadcast-message>

      <div [ngClass]="['frame-main', (activeApp$ | async) || '', 'grow', 'overflow-auto', 'relative']">
        <aipb-inside-loading [loading]="loading$ | async"></aipb-inside-loading>

        <div [ngClass]="['md:h-full', (forceFullHeight$ | async) ? 'h-full' : '']">
          <ng-content select="[frame-main]"></ng-content>
        </div>
      </div>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
